var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from "react";
import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography, CircularProgress, useTheme, Chip, } from "@mui/material";
import { StyledTableCell, StyledTableRow, TableRowsLoader, } from "../../components/mui-table/mui-table-helper";
import { Pencil, Trash } from "@phosphor-icons/react";
import { toast } from "react-toastify";
import OriginFormSubmit from "./OriginFormSubmit";
import OriginApi from "../../../infrastructure/api/pages/origin-api";
import { Layout } from "../../components/Layout/Layout";
import { useTranslation } from "react-i18next";
import OriginTopHeader from "./OriginTopHeader";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import { checkCreateEdit, checkDelete, checkManage, } from "../../../application/common/utils/roles-helper";
import { Modules } from "../../../application/common/enums/screen-name";
const initialFormData = {
    id: undefined,
    name: "",
    backgroundColor: "#000000",
    textColor: "#FFFFFF",
};
export const Origins = () => {
    const theme = useTheme();
    const [origins, setOrigins] = useState([]);
    const [origin, setOrigin] = useState(initialFormData);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [originModalOpen, setOriginModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [idToBeDeleted, setIdToBeDeleted] = useState();
    const { t: translate } = useTranslation();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    const [modalTitle, setModalTitle] = useState("");
    useEffect(() => {
        const fetchOrigins = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            try {
                const response = yield OriginApi.getAllOrigins();
                if (response.status === 200 && response.data) {
                    setOrigins(response.data);
                }
            }
            finally {
                setLoading(false);
            }
        });
        fetchOrigins();
    }, [refreshGrid]);
    const handleDeleteOrigin = (id) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!id)
            return;
        setDeleting(true);
        setIdToBeDeleted(id);
        try {
            const result = yield OriginApi.deleteOriginById(id);
            if (result === null || result === void 0 ? void 0 : result.data) {
                toast.info(translate("OriginDeletedSuccessfully"));
                setRefreshGrid(!refreshGrid);
            }
        }
        catch (error) {
            const errorMessage = ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || ((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) || (error === null || error === void 0 ? void 0 : error.message);
            // Handle specific error cases
            if (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.includes("assigned to")) {
                toast.error(translate("OriginAssignedToObjects") || errorMessage);
            }
            else {
                toast.error(translate("ErrorDeleteOrigin"));
            }
        }
        finally {
            setDeleting(false);
            setIdToBeDeleted(undefined);
        }
    });
    const handleNewOrigin = () => {
        setOrigin(initialFormData);
        setModalTitle("NewOrigin");
        setOriginModalOpen(true);
    };
    const handleEditOrigin = (originToEdit) => {
        setOrigin(originToEdit);
        setModalTitle("UpdateOrigin");
        setOriginModalOpen(true);
    };
    const onCloseOriginModal = () => {
        setOriginModalOpen(false);
        setOrigin(initialFormData);
    };
    const columns = [
        { id: "name", label: translate("Name"), minWidth: 150, align: "left" },
        { id: "backgroundColor", label: translate("BackgroundColor"), minWidth: 150, align: "left" },
        { id: "textColor", label: translate("TextColor"), minWidth: 150, align: "left" },
    ];
    if (checkCreateEdit(RolesPermissions, Modules.RoleManagement) ||
        checkManage(RolesPermissions, Modules.RoleManagement)) {
        columns.push({
            id: "action",
            label: translate("Action"),
            minWidth: 100,
            align: "left",
        });
    }
    return (_jsxs(Layout, { children: [_jsx(OriginTopHeader, { openPopup: handleNewOrigin, translate: translate }), _jsx(Box, { sx: {
                    marginTop: "1%",
                    padding: { xs: "16px 16px", sm: "16px 32px" },
                    bgcolor: theme.palette.common.white,
                    borderRadius: "24px",
                }, children: _jsx(Paper, { sx: { width: "100%", overflow: "hidden", boxShadow: "none" }, children: _jsx(TableContainer, { sx: { maxHeight: "calc(100vh - 250px)", overflowY: "auto" }, children: _jsxs(Table, { stickyHeader: true, "aria-label": "sticky table", children: [_jsx(TableHead, { children: _jsx(TableRow, { sx: { backgroundColor: theme.palette.common.white }, children: columns.map((column) => (_jsx(StyledTableCell, { align: column.align, style: { minWidth: column.minWidth }, children: _jsx(Typography, { variant: "h6", sx: {
                                                    color: theme.palette.text.primary,
                                                    fontSize: {
                                                        xs: "0.875rem",
                                                        sm: "1rem",
                                                        md: "1.25rem",
                                                    },
                                                }, children: translate(`${column.label}`) }) }, column.id))) }) }), _jsx(TableBody, { children: loading ? (_jsx(TableRowsLoader, { rowsNum: 10, cellNum: 4 })) : (origins.map((origin) => (_jsxs(StyledTableRow, { children: [_jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: origin.name }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Chip, { label: origin.backgroundColor, sx: {
                                                        backgroundColor: origin.backgroundColor,
                                                        color: origin.textColor,
                                                        fontWeight: "bold",
                                                    } }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Chip, { label: origin.textColor, sx: {
                                                        backgroundColor: origin.textColor,
                                                        color: origin.backgroundColor,
                                                        fontWeight: "bold",
                                                    } }) }), _jsx(StyledTableCell, { align: "left", children: _jsxs(Grid, { container: true, sx: {
                                                        alignContent: "left",
                                                        justifyContent: "left",
                                                        gap: { xs: 3, sm: 1 }
                                                    }, children: [checkCreateEdit(RolesPermissions, Modules.RoleManagement) && (_jsx(Grid, { size: 3, children: _jsx(Box, { sx: {
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    bgcolor: "#F4FCFF",
                                                                    borderRadius: "50%",
                                                                    width: "36px",
                                                                    height: "36px",
                                                                }, children: _jsx(Pencil, { onClick: () => handleEditOrigin(origin) }) }) })), checkDelete(RolesPermissions, Modules.RoleManagement) && (_jsx(Grid, { size: 3, children: _jsx(Box, { sx: {
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    bgcolor: "#F4FCFF",
                                                                    borderRadius: "50%",
                                                                    width: "36px",
                                                                    height: "36px",
                                                                }, children: deleting && idToBeDeleted === origin.id ? (_jsx(CircularProgress, { size: 24, color: "inherit" })) : (_jsx(Trash, { onClick: () => handleDeleteOrigin(origin.id) })) }) }))] }) })] }, origin.id)))) })] }) }) }) }), _jsx(OriginFormSubmit, { open: originModalOpen, onClose: onCloseOriginModal, GetOrigins: () => setRefreshGrid(!refreshGrid), initialFormData: initialFormData, data: origin, title: translate(modalTitle) })] }));
};
export default Origins;
